import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  HostBinding
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { ProductService } from '../../services/product.service';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { ShoppingCart, MonitorModel } from '../../models/shopping-cart.model';
import { Subscription, Subject } from 'rxjs';
import { CommonService } from '../../services/common.service';
import { ProductDetail } from '../../models/product-detail.model';
import { FileService } from '../../services/file.service';
import { Image, Link, Pdf, Specification, Option, Specification_Extended } from '../../models/product-view.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
// tslint:disable-next-line:import-blacklist
import { NgbCarousel, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { SpecificationModel } from '../../models/specification.model';
import { ProductPricingModel, Out } from '../../models/product-pricing.model';
import { BrandListReturn } from '../../models/search-brand-result.model';
import { sortingInfo } from '../../models/filter.model';
import { NgModel, FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { OptionsFilterPipe } from '../../shared/pipes/options.pipe';
import { SendEnquiryComponent } from '../../popup-collection/send-enquiry/send-enquiry.component';
import { WatchListService } from '../../services/watch-list.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { InsertWatchListItem } from '../../actions/watchlist.actions';
import { InsertShoppingCartItem } from '../../actions/shoppingcart.actions';
import { getSelectedShoppingCart, getShoppingCartLoaded } from '../../reducers/shoppingcart.reducer';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';
import {ApiResponse} from '../../models/api-response.model';
import { MatDialog } from '@angular/material/dialog';
import { filter, takeUntil } from 'rxjs/operators';
import { Sort } from '@angular/material/sort';


declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-product.page',
  templateUrl: './product.detail.component.html',
  styleUrls: ['./product.detail.component.css'],
  providers: [NgbCarouselConfig, DatePipe]
})
export class ProductDetailComponent implements OnInit, OnDestroy {

  activeSliderId;
  CurrentImageArrindex;

  location = false;
  loadContent = false;
  animationFinished = false;
  // product data
  stockCode: string;
  stockCodeList: string[] = [];
  stckCodeBundled: string;
  imageList: Image[] = [];
  pdfList: Pdf[] = [];
  linkList: Link[] = [];
  imageUrl: string;
  specificationList: Specification[] = [];
  optionList: Option[] = [];
  optionListCategory: string[] = [];
  optionListGroupByCategory: { [k: string]: Option[] } = {};
  specificationExtendedList: Specification_Extended[] = [];


  // specification data
  specification: SpecificationModel;
  hasSpecification = false;
  hasSpec = false;
  imageBanner: Image[] = [];
  imageBannerList: Image[] = [];

  // options price data
  productPricing: ProductPricingModel;
  sortedData: ProductPricingModel;
  // shopping cart
  productDetailModel: ProductDetail;
  // getFullStockProductDetails: ProductDetail;
  getFullStockProductDetails: ProductPricingModel;

  shoppingCarts: ShoppingCart[];
  cartId: number;
  cartName: string;
  inputQty = '1';
  randomNameArray: string;
  sohType: string;
  soh: string;
  subscription:Subscription;

  // this will contain the route of the window that lead to the current window
  routeLast: string;

  // tabs
  hasContentProductDetail = false;
  hasFullStockDetails = false;

  // tab contents
  hasNotes: boolean = undefined;
  imageSize: number;
  pdfSize: number;

  // breadcrumb
  buyButtonClicked = false;

  // search and filter
  filterInput = '';
  filterResultArr = undefined;
  searchResult: BrandListReturn[];
  hasEmptyFilterResult = false;
  selectedBrands = [];
  selectedTypes = [];
  selectedCategories = [];
  selectedSeriese = [];
  searchProductClicked = false;
  subscriptionSearchParaWatcher: Subscription;
  globallySearch = false;
  hasEmptyResult = true;

  searchBrandList: string[] = [];
  searchTypeList: string[] = [];
  searchCatList: string[] = [];
  searchSerList: string[] = [];
  fixedBrandList = [];
  brandList = [];
  fixedTypeList = [];
  typeList = [];
  catList = [];
  serList = [];
  fixedCatList = [];
  fixedSerList = [];
  hasBrandAutoSelected = false;
  hasTypeAutoSelected = false;
  hasCatAutoSelected = false;
  hasSerAutoSelected = false;

  showCategory = true;
  showType = true;
  showSeries = true;
  filterBy = [];
  selectedFilterBy = [];
  categories: Out[] = [];
  types: Out[] = [];
  series: Out[] = [];

  // id = primary + secondary
  // value = ProductPricingModel[]
  groupedData: { groupName: string, data: Out[] }[] = []

  startDate = Date.now();
  tDate: string;
  isPromotion = false;
  hasBundled = false;
  isBundledPromotioin = false;
  hasImage = false;
  sortingInfoObj: sortingInfo = {
    comparedProperty: '',
    sortingOrder: ''
  };
  // tab id
  overview: string;
  specs: string;
  options: string;
  resources: string;
  overviewText: string;
  links: string;
  // unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();
  backDropWidth: string;
  // sort
  testingString = 1;

  imageForm: FormGroup;
  urlPath: string;
  urlParentPath: string;
  urlParent: string;
  urlCurrent: string;
  urlCatParent: string;
  urlCatCurrent: string;
  sildeImageIndex;
  fileName: string;
  overviewPreWrap = false;
  out_freight_policy: string;

  hasRewards = false;
  lr_rewards:number = 0;

  qantasRewardsMessage = 'This product is eligible for the Qantas Business Rewards program';
  airpointRewardsMessage = 'This product is eligible for the Airpoints for Business program';
  currentUserModel: CurrentUserModel;
  @ViewChild(BreadcrumbComponent, {static: true}) breadcrumbRef: BreadcrumbComponent; // reference to the breadcrumb
  @ViewChild('myCarousel') myCarousel: NgbCarousel;


  @HostBinding('style.width')
  width = 'width';

  showDellPowerQuote:boolean = false;

  ccs_cc_args: any = [];
  constructor(
    private productService: ProductService,
    private router: Router,
    private activeRouter: ActivatedRoute,
    public commonService: CommonService,
    private shoppingCartService: ShoppingCartService,
    private watchListService: WatchListService,
    private fileService: FileService,
    private sanitization: DomSanitizer,
    private config: NgbCarouselConfig,
    private imageFd: FormBuilder,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private store: Store<AppState>,
    private authService: AuthService
  ) {
    this.config.interval = 5000;
    this.config.wrap = true;
    this.config.keyboard = false;
    this.tDate = this.datePipe.transform(this.startDate, 'yyyy-MM-dd');
  }

  stringToNumber(txt:string, toType:string){
    return toType == 'int' ? parseInt(txt) : parseFloat(txt);
  }

  numberToString(num:number) {
    return num.toString();
  }

  cycleToSlide(currentImageArrindex) {
    this.myCarousel.activeId = currentImageArrindex;
  }

  ngOnInit() {
    // $('.blockContainer').animate({ scrollLeft: $('#levelOne').width() }, 400);
    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((res: CurrentUserModel) => {
      
      this.currentUserModel = res;
    },(error: any) => {
      console.error(error);
    });

    this.activeRouter.parent.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(url => {
      this.urlPath = url !== null ? url[0].path : '';
      this.backDropWidth = '980';
      if (this.urlPath.includes('newsletter')) {
        $('.child-loader').animate({ scrollLeft: $('#cataloguelist').width() + $('#newletteritems').width() }, 400);
      } else if (this.urlPath.includes('buy')) {
        $('.child-loader').animate({ scrollLeft: $('#searchResultPageContent').width() }, 400);
      } else if (this.urlPath.includes('watchlist')) {
        $('.child-loader').animate({ scrollLeft: $('.sidebar-loader').width() + $('#watchlist').width() }, 400);
      } else if (this.urlPath.includes('cart')) {
        $('.child-loader').animate({ scrollLeft: $('.sidebar-loader').width() + $('#cart-summary').width() }, 400);
      } else if (this.urlPath.includes('openorders')) {
        $('.child-loader').animate({ scrollLeft: $('#openorders').width() + $('#shippedorders').width() + $('#orderitemdetail').width() }, 400);
      } else if (this.urlPath.includes('shippedorders')) {
        $('.child-loader').animate({ scrollLeft: $('#shippedorders').width() + $('#shippedorders').width() + $('#orderitemdetail').width() }, 400);
      } else {
        this.width = '100%';
      }

      if(this.router.url.includes('myCarts/cart') && this.router.url.includes('product')) {
        $('#levelOne').animate({ scrollLeft: $('.child-sidebar').width() + $('div #cart-summary.subBlockContainer').width()}, 400);
      } else if(this.router.url.includes('myAccount/openorders/orderitemdetail') && this.router.url.includes('product')) {
        $('#levelOne').animate({ scrollLeft: $('.child-sidebar').width() + $('div #openorders.subBlockContainer').width() + $('div #orderitemdetail.subBlockContainer').width()}, 400);
      } else if(this.router.url.includes('myOrder/openorders/orderitemdetail') && this.router.url.includes('product')) {
        $('#levelOne').animate({ scrollLeft: $('.child-sidebar').width() + $('.sidebar-loader').width() + $('div #orderitemdetail.subBlockContainer').width()}, 400);
      } else if(this.router.url.includes('myAccount/shippedorders/orderitemdetail') && this.router.url.includes('product')) {
        $('#levelOne').animate({ scrollLeft: $('.child-sidebar').width() + $('div #orderitemdetail.subBlockContainer').width()}, 400);
      } else if(this.router.url.includes('myOrder/shippedorders/orderitemdetail') && this.router.url.includes('product')) {
        $('#levelOne').animate({ scrollLeft: $('.child-sidebar').width() + $('.sidebar-loader').width() + $('div #orderitemdetail.subBlockContainer').width()}, 400);
      }
    });

    this.activeRouter.parent.parent.url.subscribe(url => {
      this.urlParentPath = url !== null ? url[0].path : '';
      if (this.urlParentPath === 'shippedorders') {
        $('.subBlockContainer').animate({ scrollLeft: $('#orderitemdetail').width() }, 200);
      }
    });

    /*shippedorders/orderitemdetail/ bundledproduct scroll bar flow*/
    this.activeRouter.parent.parent.url.subscribe(urlP => {
      this.urlParent = urlP !== null ? urlP[0].path : '';
      this.activeRouter.url.subscribe(urlC => {
        this.urlCurrent = urlC !== null ? urlC[0].path : '';
        if (this.urlParent.includes('orderitemdetail') && this.urlCurrent.includes('bundledproduct')) {
          $('.subBlockContainer').animate({ scrollLeft: $('#orderitemdetail').width() + $('#productDetail').width() }, 200);
        }
      });
    });

    /*shippedorders/orderitemdetail/ bundledproduct scroll bar flow*/
    this.activeRouter.parent.parent.url.subscribe(urlCatP => {
      this.urlCatParent = urlCatP !== null ? urlCatP[0].path : '';
      this.activeRouter.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(urlCatC => {
        this.urlCatCurrent = urlCatC !== null ? urlCatC[0].path : '';
        if (this.urlParent.includes('newsletter') && this.urlCatCurrent.includes('bundledproduct')) {
          $('.child-loader').animate({ scrollLeft: $('#cataloguelist').width() + $('#newletteritems').width() + $('#productDetail').width() }, 400);
        }
      });
    });
    /*subscript to watch the route para changes.
    **************Please make changes inside this subscription. Don't delete it ***************/
    this.activeRouter.paramMap.subscribe(param => {
      this.loadContent = false;

      $('.combination-loader').animate(
        { scrollLeft: (5000) },
        {
          duration: 400,
          complete: function () {
            $('.combination-loader').stop(true, false);
          }        
        });      
        
        // const url = decodeURIComponent(this.router.url);       
                     
        // if (url !== this.router.url) {
        //  this.router.navigateByUrl(url);
        // }
      /*get stockCode from url, push into stockCodeList array, which is used for GetProductPricing(array) api*/
      this.stockCodeList = [];
      this.stockCode = this.commonService.DDskuDecode(param.get('sku'));
      this.stockCodeList.push(this.stockCode);
      //this.stockCodeList.push((this.stockCode));

      /*get searched product details*/
      this.shoppingCartService.currentChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: MonitorModel) => {
        this.productService.GetProductPricing(this.stockCodeList)
          .subscribe((data: ProductPricingModel) => {
            var productData = {out_brand: data.output[0]?.out_brand, out_stock_code: data.output[0]?.out_stock_code };

            const brand = data.output[0]?.out_brand.trim().toLocaleLowerCase();
            const stockGroup = data.output[0]?.out_stock_group.trim();

              // tslint:disable-next-line:triple-equals
            this.showDellPowerQuote = (brand === 'dell' && (stockGroup == '27DS' || stockGroup == '27SO'));

            this.out_freight_policy = data.output[0]?.out_freight_policy;
            this.getFullStockProductDetails = data;
            this.getFullStockProductDetails.output.forEach(p => {
              this.soh = p.out_stock_code;
              /*promotion check*/
              if (this.tDate <= p.out_promo_end_date.split('-').reverse().join('-') &&
                this.tDate >= p.out_promo_start_date.split('-').reverse().join('-')) {
                this.isPromotion = true;
              }
              /*hasBundled check*/
              if (p.out_bundled_Product !== null) {
                this.hasBundled = true;
              }

              /*Qantas Rewards Check */
              if (p.out_rewards && Number(p.out_rewards) > 0) this.hasRewards = true;
              this.lr_rewards = Number(p.out_rewards);

              // if (p.out_stock_type === 'K') {
              //   p.out_bundled_Product.forEach(
              //     bp => {
              //       if (this.stockCode.includes(bp.out_stock_code)) {
              //         this.stockCode = bp.out_stock_code;
              //       }
              //     }
              //   );
              // }
            });

            this.productService.GetSpecification(this.stockCodeList).pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((spec: SpecificationModel) => {
                this.overview = 'overview' + this.stockCode;
                this.specs = 'specs' + this.stockCode;
                this.options = 'options' + this.stockCode;
                this.resources = 'resources' + this.stockCode;
                this.links = 'links' + this.stockCode;
                this.specification = spec;

                if (this.specification.files == null && this.specification.images == null && this.specification.options == null && this.specification.specs.length === null) {
                  this.hasSpecification = false;
                } else {
                  this.hasSpecification = true;
                }
                if (this.specification.overview && this.specification.overview.length > 0) {
                  const pattern: RegExp = /(<([^>]+)>)/;
                  this.overviewText = this.specification.overview;
                  if (!pattern.test(this.overviewText)) {
                    this.overviewPreWrap = true;
                  } else {
                    this.overviewPreWrap = false;
                  }
                }
                // console.log(this.specification);
                if (this.specification.specs !== null) {
                  this.specification.specs.forEach(s => {
                    if (s.out_value.length !== 0) {
                      this.hasSpec = true;
                    }
                  });
                }
               
                if (this.specification.images !== null) {
                  this.imageBanner=[];
                  this.imageBannerList=[];
                  // subscribe specification images
                  this.specification.images.forEach(img => {
                    if (img.out_description === '400 x 300' && img.out_type === 'img') {
                      this.imageBanner.push(img);
                    } else if (img.out_type === 'IMG') {
                      img.out_url = img.out_url.toLowerCase().startsWith('http://cdn.cnetcontent.com') ? img.out_url.replace('http', 'https') : img.out_url;
                      this.imageBanner.push(img);
                    } else if (img.out_description === '200 x 150') {
                      this.imageBannerList.push(img);
                    }
                  });
                }

                if (this.imageBanner.length !== 0) {
                  this.hasImage = true;
                }
                // save options stockcode as a string list in optionListCategory
                if (this.specification.options !== null) {
                  if (this.specification.options.length !== 0) {
                    this.specification.options.forEach(opt => {
                      this.optionListCategory.push(opt.stock_code);
                    });
                    this.productService.GetProductPricing(this.optionListCategory).pipe(takeUntil(this.ngUnsubscribe))
                      .subscribe((optp: ProductPricingModel) => {
                        this.filterBy = [];
                        this.selectedFilterBy = [];
                        //maintain same position of options when they are returned back from Pronto
                        this.mapOrder(optp.output, this.optionListCategory, 'out_stock_code');
                        this.productPricing = optp;
                        this.sortedData = optp;
                        this.loadContent = true;
                        if (this.sortedData.output != null) {
                          this.sortedData.output = this.sortedData.output.slice();

                          this.types = this.sortedData.output.filter(i => i.out_primary_web_cat !== '');
                          this.categories = this.sortedData.output.filter(x => x.out_secondary_web_cat !== '');
                          this.series = this.sortedData.output.filter(y => y.out_tertiary_web_cat !== '');

                          this.sortedData.output.forEach(product => {
                            const found = this.groupedData.findIndex(pair => pair.groupName === `${product.out_primary_web_cat} - ${product.out_secondary_web_cat}`)
                            if (found >= 0) {
                              this.groupedData[found].data.push(product)
                            } else {
                              this.groupedData.push({ groupName: `${product.out_primary_web_cat} - ${product.out_secondary_web_cat}`, data: [product]})
                            }
                          })

                          if (this.types.length > 0) {
                            this.filterBy.push({ 'name': 'Type' });
                          }
                          if (this.categories.length > 0) {
                            this.filterBy.push({ 'name': 'Category' });
                          }
                          if (this.series.length > 0) {
                            this.filterBy.push({ 'name': 'Series' });
                          }
                        }
                        if (this.productPricing.output !== null) {
                          this.brandList = this.productPricing.output.map((item) => {
                            return item.out_brand === '' ? 'UNKNOWN' : item.out_brand;
                          });
                          this.fixedBrandList = this.brandList.filter((item, index) => {
                            return this.brandList.indexOf(item) === index;
                          });

                          this.typeList = this.productPricing.output.map((item) => {
                            return item.out_primary_web_cat === '' ? 'UNKNOWN' : item.out_primary_web_cat;
                          });
                          this.fixedTypeList = this.typeList.filter((item, index) => {
                            return this.typeList.indexOf(item) === index;
                          });

                          this.catList = this.productPricing.output.map((item) => {
                            return item.out_secondary_web_cat === '' ? 'UNKNOWN' : item.out_secondary_web_cat;
                          });
                          this.fixedCatList = this.catList.filter((item, index) => {
                            return this.catList.indexOf(item) === index;
                          });

                          this.serList = this.productPricing.output.map((item) => {
                            return item.out_tertiary_web_cat === '' ? 'UNKNOWN' : item.out_tertiary_web_cat;
                          });
                          this.fixedSerList = this.serList.filter((item, index) => {
                            return this.serList.indexOf(item) === index;
                          });
                        }
                      },
                        (error: any) => {
                          console.error(error);
                          this.loadContent = true;
                        });
                  }
                }
                setTimeout(()=>{
                  if(this.currentUserModel.isAU) {
                    $('.vendor-intergration').run1WorldSync(productData);
                  } else {
                    $('.vendor-intergration').run1WorldSyncNZ(productData);
                  }
                },500)
              },
                (error: any) => {
                  console.error(error);
                  this.loadContent = true;
                });
          },
            (error: any) => {
              this.loadContent = true;
              console.error(error);
            });
      },
        (error: any) => {
          this.loadContent = true;
          console.error(error);
        });
      /* End */


      // detect route changes when end user click the breadcrumb, and slide to the relative component.
      this.router.events.pipe(filter(event => event instanceof NavigationEnd),takeUntil(this.ngUnsubscribe)).subscribe(res => {
        // console.log(this.router.url);
        if (this.router.url === '/buy' && this.buyButtonClicked) {

          $('.page-contents').animate({ scrollLeft: -$('#levelOne').outerWidth() }, 400);
        }
        if (this.router.url.includes('/buy/result') && this.buyButtonClicked) {

          $('.page-contents').animate({ scrollLeft: $('#levelOne').outerWidth() }, 400);
        }
        this.buyButtonClicked = false;
      });

    });


    this.store.select(getShoppingCartLoaded).pipe(takeUntil(this.ngUnsubscribe)).subscribe(isLoaded => {
      if (isLoaded) {
        this.store.select(getSelectedShoppingCart).pipe(takeUntil(this.ngUnsubscribe)).subscribe(cart => {
          if (cart) {
            this.cartId = cart.cartId;
            this.cartName = cart.cartName;
          }
        });
      }
    });


    this.imageForm = this.imageFd.group({
      downloadImage: this.imageFd.array([])
    });
  }

  sortData(sort: Sort) {
    const data = this.sortedData.output.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData.output = data;
    }

    this.sortedData.output = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'des': return compare(a.out_description, b.out_description, isAsc);
        case 'soh': return compare(a.out_avail_stock_qty, b.out_avail_stock_qty, isAsc);
        case 'price': return compare(a.out_current_price, b.out_current_price, isAsc);
        // case 'qty': return compare(a.lr_stock_code, b.lr_stock_code, isAsc);
        default: return 0;
      }
    });
  }
  setOptionsListByCategory() {
    for (let i = 0; i < this.optionList.length; i++) {
      this.optionListGroupByCategory[this.optionList[i]['category']] = [];
    }
    for (let i = 0; i < this.optionList.length; i++) {
      this.optionListGroupByCategory[this.optionList[i]['category']].push(this.optionList[i]);
    }
  }


  addToCart(stockCode: string, qty: string): void {
    this.store.dispatch(new InsertShoppingCartItem({ stockCode: encodeURIComponent(stockCode), cartId: this.cartId, Qty: qty }));
  }

  addToWatchList(item: Out): void {
    this.store.dispatch(new InsertWatchListItem(item));
  }


  changeCart(val: string): void {
    if (val === 'add') {
      this.randomNameArray = this.shoppingCartService.RandomCartName(this.shoppingCarts);
      this.shoppingCartService.createShoppingCart(this.randomNameArray).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: number) => {
        this.shoppingCartService.monitorCartId(res);
        this.shoppingCartService.monitorCartIdChange(res);
        this.commonService.savecookies('CartId', res.toString(), 7);
        this.shoppingCartService
          .getShoppingCart().pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(sc => {
            this.shoppingCarts = sc;
          },
            (error: any) => console.error(error));
      });
    } else {
      this.shoppingCartService.monitorCartId(this.commonService.toNumber(val));
      this.shoppingCartService.monitorCartIdChange(this.shoppingCarts.filter(x => x.cartId.toString() === val)[0].cartId);
      this.commonService.savecookies('CartId', val, 7);
    }
  }

  viewCart(): void {
    this.router.navigateByUrl('/myCarts/cart/' + this.cartId + '/' + this.cartName);
  }

  downloadFile(url, type, des): void {
    event.preventDefault();
    this.fileService.saveFile(url).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (des === '' || des === null) {
        this.fileName = type;
      } else {
        this.fileName = des;
      }
      switch (type) {
        case 'image':
          this.fileService.saveAsImageFile(res, this.fileName);
          break;
        case 'pdf':
          this.fileService.saveAsPdf(res, this.fileName);
          break;
      }
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }
  downloadFiles(): void {
    event.preventDefault();
    if (this.imageForm.value.downloadImage.length !== 0) {
      this.imageForm.value.downloadImage.forEach(img => {
        if (img.out_type === 'img') {
          const url = img.out_url.replace('http:', 'https:');
          this.downloadFile(url, 'image', img.out_description);
        } else if (img.out_type === 'pdf') {
          const url = img.out_url.replace('http:', 'https:');
          this.downloadFile(url, 'pdf', img.out_description);
        } else if (img.out_type === 'IMG') {
          const url = img.out_url.replace('http:', 'https:');
          this.downloadFile(url, 'image', img.out_description);
        } else if (img.out_type === 'PDF') {
          // const url = img.out_url.replace('http:', 'https:');
          this.downloadFile(img.out_url, 'pdf', img.out_description);

        }

      });
    }
  }

  isNumberKey(event: any) {

    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  safeImageUrl(url: string): SafeUrl {
    return this.sanitization.bypassSecurityTrustUrl(url);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  goToLink(url: string) {
    window.open(url, '_blank');
  }

  close() {

    if (this.urlPath.includes('watchlist')) {
      $('#levelOne').animate({ scrollLeft: -($('.sidebar-loader').width() + $('#watchlist').width()) }, 400);
    }

    if (this.urlPath.includes('newsletter')) {
      $('.child-loader').animate({ scrollLeft: $('#cataloguelist').width() }, 400);
    } else {
      $('.page-contents').animate({ scrollLeft: $('#levelOne').outerWidth() }, 400);
    }

    if (this.urlPath.includes('buy')) {
      //this.router.navigateByUrl('/buy?showresult=true');
      // this.router.navigateByUrl('/buy?globalSearch=' + this.stockCode);
      this.router.navigate(['../../'], { relativeTo: this.activeRouter, queryParamsHandling:'preserve'})
    } else if (this.urlParentPath.includes('shippedorders')) {
      this.router.navigate(['../../'], { relativeTo: this.activeRouter });
      $('.subBlockContainer').animate({ scrollLeft: 0 }, 0);
    } else {
      this.router.navigate(['../../'], { relativeTo: this.activeRouter });
    }

    if (this.urlParent.includes('orderitemdetail') && this.urlCurrent.includes('bundledproduct')) {
      this.router.navigate(['../../'], { relativeTo: this.activeRouter });
      $('.subBlockContainer').animate({ scrollLeft: $('#orderitemdetail').width() }, 200);
    }

    if (this.urlParent.includes('newsletter') && this.urlCurrent.includes('bundledproduct')) {
      $('.child-loader').animate({ scrollLeft: $('#cataloguelist').width() + $('#newletteritems').width() }, 400);
    }

    if(this.router.url.includes('myAccount/openorders/orderitemdetail') && this.router.url.includes('product')) {
      $('#levelOne').animate({ scrollLeft: $('.child-sidebar').width() + $('div #openorders.subBlockContainer').width()}, 400);
    } else if(this.router.url.includes('myOrder/openorders/orderitemdetail') && this.router.url.includes('product')) {
      $('#levelOne').animate({ scrollLeft: $('.child-sidebar').width() }, 400);
    } else if(this.router.url.includes('myAccount/shippedorders/orderitemdetail') && this.router.url.includes('product')) {
      $('#levelOne').animate({ scrollLeft: 0 }, 400);
    } else if(this.router.url.includes('myOrder/shippedorders/orderitemdetail') && this.router.url.includes('product')) {
      $('#levelOne').animate({ scrollLeft: $('.child-sidebar').width() }, 400);
    }
  }


  onClicked(message: string): void {
    if (message === 'clicked') {
      this.buyButtonClicked = true;
    }
  }

  openedChange(opened: boolean, allSelected, selectedFilterValues: NgModel) {
    if (!opened) {
      if (allSelected.selected) {
        selectedFilterValues.update.emit([]);
      }
    }
  }

  onChange() {
    this.filterResultArr = new OptionsFilterPipe().transform(this.productPricing.output, this.selectedBrands, this.selectedTypes, this.selectedCategories, this.selectedSeriese, this.filterInput);
    if (this.filterResultArr.length === 0) {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  onFilterChange(): void {
    if (this.selectedFilterBy.length === 0) {
      this.showCategory = true;
      this.showType = true;
      this.showSeries = true;

      return;
    }

    this.showType = this.selectedFilterBy.indexOf('Type') > -1 ? true : false;
    this.showCategory = this.selectedFilterBy.indexOf('Category') > -1 ? true : false;
    this.showSeries = this.selectedFilterBy.indexOf('Series') > -1 ? true : false;
  }

  onSelectAll(): void {
    this.selectedFilterBy = this.filterBy.map(item => item.name);

    this.onFilterChange();
  }

  onClearAll(): void {
    this.selectedFilterBy = [];

    this.onFilterChange();
  }

  filterReset(): void {

    this.hasEmptyFilterResult = false;
    this.filterResultArr = undefined;

    this.selectedBrands = [];
    this.selectedTypes = [];
    this.selectedCategories = [];
    this.selectedSeriese = [];
    this.selectedFilterBy = [];

    this.filterInput = '';

    this.sortingInfoObj.comparedProperty = '';
    this.sortingInfoObj.sortingOrder = '';

    this.onFilterChange();
  }

  filterBrands(event: any): void {
    this.searchBrandList = [];
    this.searchBrandList = event.value;
  }
  filterTypes(event: any): void {
    this.searchTypeList = [];
    this.searchTypeList = event.value;
  }
  filterCats(event: any): void {
    this.searchCatList = [];
    this.searchCatList = event.value;
  }
  filterSers(event: any): void {
    this.searchSerList = [];
    this.searchSerList = event.value;
  }

  // called when All option is clicked
  toggleAllSelection(seletedFilter, selectedFilterValues: NgModel, comparedFixedList: string[], allSelected) {
    // Condition 1: every option (include 'All') is selected and click the All option
    if (seletedFilter.length === (comparedFixedList.length)) {
      selectedFilterValues.update.emit([]);
    } else if (!allSelected.selected) { // Condition 2: 'All' option is deselected and at least one other option is selected
      selectedFilterValues.update.emit(comparedFixedList);
    } else if (allSelected.selected && seletedFilter.length === 1) { // Condition 3: None of options are selected and click the All option
      selectedFilterValues.update.emit(comparedFixedList);
    } else if ((allSelected.selected && seletedFilter.length > 1) &&
      (seletedFilter.includes('all') && seletedFilter.length < comparedFixedList.length) || (!seletedFilter.includes('all') && seletedFilter.length < (comparedFixedList.length - 1))) {
      selectedFilterValues.update.emit(comparedFixedList);
    } else {
      selectedFilterValues.update.emit([]);
    }
  }
  tickAllOptionsByOpeningPanel(event, fixedFilterList, selectedFilterValues: NgModel, seletedFilter) {
    // check if the panel is opened
    if ($(event.target).closest('.mat-input-flex.mat-form-field-flex').length) {
      if (seletedFilter.length === 0) {
        selectedFilterValues.update.emit(fixedFilterList);
      }
    }
  }

  // called when the mat-select has any changes.
  updateFilterList(seletedFilter, fixedFilterList, allSelect, hasAutoSelected, filterName) {
    if (seletedFilter.includes('all') && seletedFilter.length === (fixedFilterList.length - 1)) {
      allSelect.deselect();
    } else if ((seletedFilter.length <= fixedFilterList.length) && allSelect.selected && seletedFilter.length !== 1 && !hasAutoSelected) { // if 'All' option is selected, but user deselect any other option => 'All' option will be deselected by default.
      allSelect.deselect();
      if (filterName === 'brand') {
        this.hasBrandAutoSelected = false;
      } else if (filterName === 'type') {
        this.hasTypeAutoSelected = false;
      } else if (filterName === 'category') {
        this.hasCatAutoSelected = false;
      } else {
        this.hasSerAutoSelected = false;
      }
      return;
    } else if ((seletedFilter.length === (fixedFilterList.length - 1)) && !seletedFilter.includes('all')) { // if All option is deselected, but the rest options are selected. => 'All' option will be selected by default.
      allSelect.select();
      if (filterName === 'brand') {
        this.hasBrandAutoSelected = true;
      } else if (filterName === 'type') {
        this.hasTypeAutoSelected = true;
      } else if (filterName === 'category') {
        this.hasCatAutoSelected = true;
      } else {
        this.hasSerAutoSelected = true;
      }
      return;
    }

  }
  addByDescendAscend(input: string, sortingOrder: string) {
    if (input == null) {
      this.inputQty = '0';
      // tslint:disable-next-line:radix
    } else if (parseInt(input) < 0) {
      this.inputQty = '0';
    } else {
      if (sortingOrder === 'descending') {
        // tslint:disable-next-line:radix
        this.inputQty = (parseInt(input) + 1).toString();
      } else {
        // tslint:disable-next-line:radix
        if ((parseInt(input) - 1) < 0) {
          this.inputQty = '0';
        } else {
          // tslint:disable-next-line:radix
          this.inputQty = (parseInt(input) - 1).toString();
        }
      }
    }

    // if (input == null || parseInt(input) < 0) {
    //     this.inputQty = '0';
    // } else if ()
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  openModel(i) {
    this.sildeImageIndex = i;
    $('#zoomImage').appendTo('body').modal('show');
  }

  onChangeImg(imgUrl, isChecked: boolean) {
    const imgFormArray = <FormArray>this.imageForm.controls.downloadImage;
    if (isChecked) {
      imgFormArray.push(new FormControl(imgUrl));

    } else {
      const index = imgFormArray.controls.findIndex(x => x.value === imgUrl);
      imgFormArray.removeAt(index);
    }
  }

  goToRewards() {
    this.router.navigateByUrl('/rewards');
  }

  pageChange(event: any) {
    $('.page-contents').animate({ scrollLeft: $('#levelOne').outerWidth() }, 100);
    // $('.page-contents').animate({ scrollLeft: -$('#levelOne').outerWidth() }, 400);
    // $('.page-contents').animate({ scrollLeft: $('#levelOne').outerWidth() }, 400);
  }

  checkProductDetail(stockCode: string): void {
    stockCode = encodeURIComponent(stockCode);
    this.router.navigate([`bundledproduct/${stockCode}`], { relativeTo: this.activeRouter });
  }

  GetDellPowerQuotes(sku: string) {
    this.loadContent = false;
    this.productService.GetDellPowerQuotes(sku).subscribe((res:ApiResponse)=>{
      if (res.status) {
         const url = res.responseMessage;
         window.open(url);
      } else {
        this.loadContent = true;
        this.commonService.implementToast('Failed to open dell power quote', 'Error');
      }
    },() =>{
      this.loadContent = true;
      this.commonService.implementToast('Failed to open dell power quote', 'Error');
    });
  }

  sendEnquiry(item: Out): void {
    const brandItem = {
      lr_stock_code: item.out_stock_code,
      lr_stk_brand: item.out_brand,
      lr_stk_description: item.out_description,
      lr_secondary_cat: item.out_secondary_web_cat
    } as BrandListReturn;
    this.dialog.open(SendEnquiryComponent, {
      width: '650px',
      data: { item: brandItem }
    });
  }

  mapOrder (array, order, key) {
    array.sort( function (a, b) {
      var A = a[key], B = b[key];
      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }
    });
    return array;
  };

  get isEnquiryProduct(): boolean {
    if (this.getFullStockProductDetails) {
      return this.getFullStockProductDetails.output[0].out_web_sell === 'E'
    } else { 
      return false;
    }
  }
  
  
}
function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}


